var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.infoText)?_c('p',{staticClass:"info-text"},[_vm._v(_vm._s(_vm.infoText))]):_vm._e(),_c('ui-button',{attrs:{"color":"primary","to":_vm.to}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }